<div class="adf-page">
  <div class="adf-hero">
    <p class="adf-hero-text">
      Configure access rules and sequencing for action management. Set up hierarchy-based and parameter-based access
      controls for status, categories, and fields.
    </p>
  </div>

  <div class="adf-loader" *ngIf="!configurationLoaded">
    <app-ltms-loader></app-ltms-loader>
  </div>

  <form [formGroup]="rulesForm" class="adf-groups" *ngIf="configurationLoaded">
   <div class="adf-groups-container">
     <!-- Status Setup -->
     <section class="adf-group">
      <div class="adf-group-header">
        <h5 class="adf-group-title">Status Setup</h5>
        <p class="adf-group-desc">Configure how status changes are managed and accessed</p>
      </div>

      <div class="adf-group-body">
        <div class="adf-setting-row">
          <div class="adf-setting-copy">
            <label class="adf-setting-label" for="status-sequencing">Enable Status Sequencing</label>
            <p class="adf-setting-desc">Allow actions to follow predefined status sequences</p>
          </div>
          <div class="adf-setting-control">
            <label class="adf-switch">
              <input type="checkbox" id="status-sequencing"
                formControlName="enableStatusSequencing"
                (change)="onCheckboxChange('enableStatusSequencing', $any($event.target).checked)">
              <span class="adf-switch-slider"></span>
            </label>
          </div>
        </div>

        <div class="adf-setting-row">
          <div class="adf-setting-copy">
            <label class="adf-setting-label" for="status-hierarchy">Enable Hierarchy Based Access</label>
            <p class="adf-setting-desc">Control status access based on user hierarchy levels</p>
          </div>
          <div class="adf-setting-control">
            <label class="adf-switch">
              <input type="checkbox" id="status-hierarchy"
                formControlName="enableStatusHierarchyAccess"
                (change)="onCheckboxChange('enableStatusHierarchyAccess', $any($event.target).checked)">
              <span class="adf-switch-slider"></span>
            </label>
          </div>
        </div>

        <div class="adf-setting-row">
          <div class="adf-setting-copy">
            <label class="adf-setting-label" for="status-parameter">Enable Parameter Based Access</label>
            <p class="adf-setting-desc">Control status access based on action parameters</p>
          </div>
          <div class="adf-setting-control">
            <label class="adf-switch">
              <input type="checkbox" id="status-parameter"
                formControlName="enableStatusParameterAccess"
                (change)="onCheckboxChange('enableStatusParameterAccess', $any($event.target).checked)">
              <span class="adf-switch-slider"></span>
            </label>
          </div>
        </div>
      </div>
        <div class="adf-group-footer">
          <button type="button" class="adf-btn adf-btn--ghost" (click)="cancelConfiguration('status')"
            [disabled]="!isStatusSaveEnabled || isCancellingSection === 'status' || readonly">Cancel</button>
          <button type="button" class="adf-btn adf-btn--primary" (click)="saveConfiguration('status')"
            [disabled]="!isStatusSaveEnabled || isSavingSection === 'status' || readonly">Save</button>
        </div>
    </section>

    <!-- Category Setup -->
    <section class="adf-group">
      <div class="adf-group-header">
        <h5 class="adf-group-title">Category Setup</h5>
        <p class="adf-group-desc">Configure access rules for action categories</p>
      </div>

      <div class="adf-group-body">
        <div class="adf-setting-row">
          <div class="adf-setting-copy">
            <label class="adf-setting-label" for="category-hierarchy">Enable Hierarchy Based Access</label>
            <p class="adf-setting-desc">Control category access based on user hierarchy levels</p>
          </div>
          <div class="adf-setting-control">
            <label class="adf-switch">
              <input type="checkbox" id="category-hierarchy"
                formControlName="enableCategoryHierarchyAccess"
                (change)="onCheckboxChange('enableCategoryHierarchyAccess', $any($event.target).checked)">
              <span class="adf-switch-slider"></span>
            </label>
          </div>
        </div>

        <div class="adf-setting-row">
          <div class="adf-setting-copy">
            <label class="adf-setting-label" for="category-parameter">Enable Parameter Based Access</label>
            <p class="adf-setting-desc">Control category access based on action parameters</p>
          </div>
          <div class="adf-setting-control">
            <label class="adf-switch">
              <input type="checkbox" id="category-parameter"
                formControlName="enableCategoryParameterAccess"
                (change)="onCheckboxChange('enableCategoryParameterAccess', $any($event.target).checked)">
              <span class="adf-switch-slider"></span>
            </label>
          </div>
        </div>
      </div>
        <div class="adf-group-footer">
          <button type="button" class="adf-btn adf-btn--ghost" (click)="cancelConfiguration('category')"
            [disabled]="!isCategorySaveEnabled || isCancellingSection === 'category' || readonly">Cancel</button>
          <button type="button" class="adf-btn adf-btn--primary" (click)="saveConfiguration('category')"
            [disabled]="!isCategorySaveEnabled || isSavingSection === 'category' || readonly">Save</button>
        </div>
    </section>

    <!-- Field Setup -->
    <section class="adf-group">
      <div class="adf-group-header">
        <h5 class="adf-group-title">Field Setup</h5>
        <p class="adf-group-desc">Configure access rules for action fields</p>
      </div>

      <div class="adf-group-body">
        <div class="adf-setting-row">
          <div class="adf-setting-copy">
            <label class="adf-setting-label" for="field-hierarchy">Enable Hierarchy Based Access</label>
            <p class="adf-setting-desc">Control field access based on user hierarchy levels</p>
          </div>
          <div class="adf-setting-control">
            <label class="adf-switch">
              <input type="checkbox" id="field-hierarchy"
                formControlName="enableFieldHierarchyAccess"
                (change)="onCheckboxChange('enableFieldHierarchyAccess', $any($event.target).checked)">
              <span class="adf-switch-slider"></span>
            </label>
          </div>
        </div>

        <div class="adf-setting-row">
          <div class="adf-setting-copy">
            <label class="adf-setting-label" for="field-parameter">Enable Parameter Based Access</label>
            <p class="adf-setting-desc">Control field access based on action parameters</p>
          </div>
          <div class="adf-setting-control">
            <label class="adf-switch">
              <input type="checkbox" id="field-parameter"
                formControlName="enableFieldParameterAccess"
                (change)="onCheckboxChange('enableFieldParameterAccess', $any($event.target).checked)">
              <span class="adf-switch-slider"></span>
            </label>
          </div>
        </div>
      </div>
        <div class="adf-group-footer">
          <button type="button" class="adf-btn adf-btn--ghost" (click)="cancelConfiguration('field')"
            [disabled]="!isFieldSaveEnabled || isCancellingSection === 'field' || readonly">Cancel</button>
          <button type="button" class="adf-btn adf-btn--primary" (click)="saveConfiguration('field')"
            [disabled]="!isFieldSaveEnabled || isSavingSection === 'field' || readonly">Save</button>
        </div>
    </section>
   </div>
  </form>
</div>
